import React from 'react';

/** Sayfa düzeni — tutarlı dikey boşluk ve hizalama. */
export function PageShell({ children, className = '' }) {
  return <div className={`page-shell ${className}`.trim()}>{children}</div>;
}
